// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';
export const environment = {
  production: true,
  hideMembersMap: true,
  version: env.npm_package_version,
  needD7: true,
  betaUrl: 'beta.ikointl.com',
  serverUrl: 'd8.ikointl.com',
  server7Url: 'www.ikointl.com',
  currentWebUrl: 'https://beta.ikointl.com',
  defaultLanguage: 'en',
  stripeKey: 'pk_live_ZbsD7OuU16eQtAQUL6AAzGDM',
  googleMapsKey: 'AIzaSyCdGIkSOHfMd8tSdU6ZZRw42XjKoJB2PiM',
  googleMapId: 'b6831b3df12eb0a9',
  googleTagManagerId: 'GTM-KB4CDQ3',
  googleAnalyticId: 'G-F30LK1VP1R',
  googleClientId: '287913706245-q9nh0942vnet0r6vj3tfdj42dlfba4o3.apps.googleusercontent.com',
  paypalClientId: 'AZhJtGrWkim0T2_EI_Eb40EMjn-WtKkMlKCwoqjfm8LTib0I-KJxLMFWZpok4Lt9qz4Iv-tCON3y9IWP',
  facebookAppId: '454627567982311',
  crispChatId: '17e72c28-5457-4172-8dff-841699c961e3',
  captchaKey: '6Lf02NEUAAAAAHsHk5l-74g9S2t7QqSHI38wLfJO',
  hostname: 'http://next.ikointl.com',
  linkGFormAddSpot:
    'https://docs.google.com/forms/d/e/1FAIpQLSdiFubnOx8DtQ8zz_E3FfX3M1z-0l2U-yozzLZCvsZuFK2Gig/viewform',
  inAppBrowsing: {
    course: true,
    quality: true,
    renew: true,
    messages: true,
    bookings: false,
    userBookings: false,
    students: {
      kiter: true,
      assistant: true,
      instructor: true,
      coach: true,
    },
    certifications: {
      request: false,
    },
  },
  mainPage: {
    cordova: '/welcome',
    ssr: '/gutenberg/306',
    login: '/user/login',
  },
};
